/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/20/20
 * Time: 6:07 PM
 */
import React, {Component} from 'react';
import './Auth.scss';
import {Modal} from "semantic-ui-react";
import * as actionSpinnerCreator from "../../../store/domain/spinner/action";
import * as actionStudentCreator from "../../../store/domain/student/action";
import {connect} from "react-redux";
import {Button} from 'reactstrap'
import * as constants from "../../../const/constants";
import {withRouter} from "react-router";
import * as commonFunc from "../../../utils/commonFunc";
import * as authService from "../../../services/auth";
import md5 from 'md5';
import qs from 'qs';
import Cookies from "js-cookie";
import Logo from "../../../assets/img/revamp/vibernets/V Academy (1).jpg";
import {lang, language} from "../../../const/language";
import webConfig from '../../../config/WebConfig'


class App extends Component {

    state = {
        username: '',
        password: '',
    };

    textOnChange = (event) => {
        let name = event.target.name;
        let value = event.target.value;

        if (name === "username") {
            if (!(value.split(" ").join("") === "" && this.state.username === "")) {
                let username = value.split(" ").join("");
                this.setState({[name]: username});
            }
        } else {
            this.setState({[name]: value});
        }
    };

    loginHandler = async () => {
        let {username, password} = this.state;

        username = username.split(" ").join("");

        if (username === "") {
            commonFunc.notifyMessage(language[lang].EmailCannotBeEmpty);
            return;
        }

        if (username !== "" && !username.includes("@")) {
            commonFunc.notifyMessage(language[lang].InvalidEmail)
            return;
        }

        if (password === "") {
            commonFunc.notifyMessage(language[lang].PasswordCannotBeEmpty)
            return;
        }

        await this.fetchHandler()

    };

    fetchHandler = async () => {
        let {username, password} = this.state;

        const obj = {
            username: username,
            password: md5(password),
            grant_type: 'password',
        };

        this.props.spinnerHandler({isSpin: true, type: 5});

        await authService.loginUser(qs.stringify(obj))
            .then(response => {
                this.props.spinnerHandler(false);

                if (response.access_token) {
                    Cookies.set(constants.ACCESS_TOKEN, response.access_token);
                    Cookies.set(constants.REFRESH_TOKEN, response.refresh_token);
                    Cookies.set(constants.VERIFY_CODE, response.verify_code);

                    this.props.userDetailsHandler(response.user.userDetails);
                    this.setModalHandler("USER");
                    return;
                }
                if (!response.success) {
                    commonFunc.notifyMessage(response.message, response.status)
                }
            })
    };
    setModalHandler = (str) => {
        if (str === "REG") {
            this.props.history.push(`${constants.BASE_ROUTE}${constants.AUTH_REG_ROUTE}`);
            return;
        }
        if (str === "FORGOT") {
            this.props.history.push(`${constants.BASE_ROUTE}${constants.AUTH_FORGOT_ROUTE}`);
            return;
        }
        if (str === "USER") {
            // window.history.back();
            this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_INSTITUTE_ROUTE}`);
            return;
        }
        this.goToHomeHandler();
    };

    goToHomeHandler = async () => {
        await commonFunc.removeCookiesValues();
        this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_INSTITUTE_ROUTE}`);
    };

    render() {

        console.log("RENDER : ", new Date())

        let {username, password} = this.state;

        return (
            <Modal size={"tiny"}
                   open={true}
                   centered={true}
                   className={"auth-modal"}>

                <Modal.Header>
                    <div className={"logo-wrapper"}>
                        <img
                            className={"logo-img"}
                            alt="..."
                            src={Logo}
                        />
                    </div>
                    <h1 className={"login-title"}>{language[lang].Welcome}</h1>
                </Modal.Header>

                <Modal.Content>
                    <p className={"p-tag"}>{language[lang].EmailAddress}</p>

                    <input className={"form-control teach-input"} name={"username"} type={"telephone"}
                           placeholder={"Enter your email address"} onChange={this.textOnChange} value={username}/>

                    <p className={"p-tag"}>{language[lang].Password}
                        <label className={"small-text bold-yellow"}
                               style={{color:'maroon'}}
                               onClick={() => this.setModalHandler("FORGOT")}>( {language[lang].ForgotYourPassword} )
                        </label>
                    </p>

                    <input className={"form-control teach-input"} name={"password"} type={"password"}
                           placeholder={"Enter your password"} onChange={this.textOnChange} value={password}/>

                    <div className={"d-flex justify-content-center align-center login-btn-wrapper"}>
                        <Button style={{backgroundColor: webConfig.secondaryColor}} className="login-new-btn"
                                onClick={this.loginHandler}>
                            {language[lang].Login}
                        </Button>
                    </div>

                    <div className={"text-center"}>
                        <label className={"small-text"} onClick={() => this.setModalHandler("REG")}>Don't have an
                            account? <span style={{color: webConfig.secondaryColor}}> Sign up now</span>
                        </label>
                    </div>

                </Modal.Content>

                <Modal.Actions onClick={() => this.setModalHandler(null)}>
                    <div className={"home-wrapper"}>
                        <i className="fa fa-home" aria-hidden="true"/>
                        <span>{language[lang].GoToTheHome}</span>
                    </div>
                </Modal.Actions>
            </Modal>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    spinnerHandler: data => dispatch(actionSpinnerCreator.spinnerHandler(data)),
    userDetailsHandler: data => dispatch(actionStudentCreator.userDetailsHandler(data)),
});

export default connect(null, mapDispatchToProps)(withRouter(App));
